/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* homepage header show on scroll */
$(function(){
  if($('.template-index').length > 0){

    var browser_height = $(window).height() - 250;

    $(window).on("scroll", function () {
        if ($(this).scrollTop() > browser_height ) {
            $('body').addClass('scrolled');
        } else {
            $('body').removeClass('scrolled');
        }
    }).on("resize", function(){ 
       browser_height = $(window).height() -250; 
    }); 
  }
});

/* Homepage Intro Section */
$(function(){
  if($('.Home-Intro').length > 0){
    setTimeout(function(){
      $('.Home-Intro .intro-image-item:first-child').addClass('current-active');
      setInterval(function(){
        runIntroImages();
      }, 1500);
    }, 1500);

    
  }
});


function runIntroImages(){
  
  var whole_list= $('.Home-Intro .intro-image-item');
  var current_item = $('.Home-Intro .intro-image-item.current-active');
  
  if($('.Home-Intro .intro-image-item:last-child').hasClass('current-active')){
    $('.Home-Intro .intro-image-item:first-child').addClass('current-active');
  	current_item.removeClass('current-active').addClass('active');
  	current_item.prev().prev().removeClass('active'); 
  }
  else if($('.Home-Intro .intro-image-item:first-child').hasClass('current-active')){
    current_item.next().addClass('current-active');
     current_item.removeClass('current-active').addClass('active');
    $('.Home-Intro .intro-image-item:nth-last-child(2)').removeClass('active')
    
  }
  else if($('.Home-Intro .intro-image-item:nth-child(2)').hasClass('current-active')) {
     current_item.next().addClass('current-active');
     current_item.removeClass('current-active').addClass('active');
     $('.Home-Intro .intro-image-item:last-child').removeClass('active');
  }else{
  current_item.next().addClass('current-active');
  current_item.removeClass('current-active').addClass('active');
  current_item.prev().prev().removeClass('active'); 
  }
  
}

/* Set Flickety Slider cells to same height */

function resize_cells(){
  /* Home Collection List */
  if($('.Home-Product-List .collection-item-content').length > 0){
    var cell_height = -1;
     $('.Home-Product-List .collection-item-content').css('min-height', 'auto');

     $('.Home-Product-List .collection-item-content').each(function(){
       if($(this).height() >= cell_height){
          cell_height = $(this).height();
        }
    })

    cell_height += 40;

    $('.Home-Product-List .collection-item-content').css('min-height', cell_height+"px")

  }
  
  
  /* Home Product List */
  if($('.Home-Product-List .product-content-top').length > 0){
    var cell_height = -1;
     $('.Home-Product-List .product-content-top').css('min-height', 'auto');

     $('.Home-Product-List .product-content-top').each(function(){
       if($(this).height() >= cell_height){
          cell_height = $(this).height();
        }
    })


    $('.Home-Product-List .product-content-top').css('min-height', cell_height+"px")

  }
  
    /* Similar Products */

  if($('#shopify-section-product-recommendations .ProductItem__Info').length > 0){
    var cell_height = -1;
     $('#shopify-section-product-recommendations .ProductItem__Info').css('min-height', 'auto');

     $('#shopify-section-product-recommendations .ProductItem__Info').each(function(){
       if($(this).height() >= cell_height){
          cell_height = $(this).height();
        }
    })


    $('#shopify-section-product-recommendations .ProductItem__Info').css('min-height', cell_height+"px")
  }
  
}


$(function(){
   resize_cells();
  setTimeout(function(){
    resize_cells();
  }, 500);

});

$( window ).resize(function() {
    resize_cells();
});

/* end resize products */

//open external links in new tab

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}

/* Visualizer */
$(function(){
  if( $('.Visualizer').length > 0){
   $('body').addClass('Visualizer-page').addClass('show');
    $('#shopify-section-cn-footer').remove();
    
    
     setTimeout(function(){
    $('body').addClass('timed-fade');
    $('body').removeClass('show');
      }, 5000);
    
    
    var timeout = false;
    
    $('body').mousemove(function(){
        $('body').addClass('show');
        timeout = false;
      
      setTimeout(function(){
        timeout = true;
      }, 4000);

    });

     $('body').on('touchstart', function(){
        $('body').addClass('show');
  		timeout = false;
       
       setTimeout(function(){
         timeout = true;
       }, 4000);
    });
    
    
    setInterval(function(){
      if(timeout){
      $('body').removeClass('show');
      }
    }, 5000);
    
    
    $('.Visualizer .ImageHero').removeClass('ImageHero').removeClass('ImageHero--large').addClass('video_wrap')
    
     
    setTimeout(function(){
    video_resize();
    }, 500);
    
    $(window).resize(function(){
      video_resize();
    })
    
  }
  

})

function video_resize(){
	 var w_height = $(window).height();
	var w_width = $(window).width();
  
  var aspectratio = w_height / w_width;
  
  console.log(aspectratio);


if( aspectratio > .565){

  var new_width = w_height*1.777;
    var new_height = w_height;
  
  $('.video_wrap iframe').attr('height', new_height);
  $('.video_wrap iframe').attr('width', new_width);
  
}else{
  
    var new_width = w_width;
    var new_height = w_width*.565;
  
  $('.video_wrap iframe').attr('height', new_height);
  $('.video_wrap iframe').attr('width', new_width);
  
}
   
}



/* Marquee Text */

$(function(){
  
  var item = document.querySelector('.MarqueeText');
  var marqueeText = new Flickity(item, {
       accessibility: true,
       resize: true,
       wrapAround: true,
       prevNextButtons: false,
       pageDots: false,
       percentPosition: true,
       setGallerySize: true,
       draggable: false
     });

    

     // Set initial position to be 0
     marqueeText.x = 0;

     // Start the marquee animation
    play();


     // Main function that 'plays' the marquee.
     function play() {
     
       marqueeText.x += 1;
   

       // Settle position into the slider
       marqueeText.settle(marqueeText.x);


       // Set the requestId to the local variable
       requestId = window.requestAnimationFrame(play);
       }




       // Main function to cancel the animation.

       function pause() {
         if(requestId) {
           // Cancel the animation
           window.cancelAnimationFrame(requestId)

           // Reset the requestId for the next animation.
           requestId = undefined;
         }
     }
  
  
    var rtime;
    var timeout = false;
    var delta = 200;
    $(window).resize(function() {
        rtime = new Date();
        if (timeout === false) {
            timeout = true;
            setTimeout(resizeend, delta);
        }
    });


    function resizeend() {
        if (new Date() - rtime < delta) {
            setTimeout(resizeend, delta);
        } else {
            timeout = false;
            setTimeout(function(){

            marqueeText.resize();
            }, 400);
        }
    }

});


/* Circle Parallax */

$(function(){
  gsap.to(".circle-edge", {
  yPercent: 200,
  ease: "none",
  scrollTrigger: {
    trigger: ".circle-edge",
    start: "top bottom",
     end: "bottom top",
    scrub: true
  }, 
});
});